var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"left":_vm.left,"top":_vm.top,"bottom":_vm.bottom,"right":_vm.right},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":_vm.iconColor,"dark":_vm.dark}},'v-icon',_vm.$attrs,false),on),[_vm._v(_vm._s(_vm.icon))])]}}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }